<template>
  <NuxtLayout>
    <div class="error" :style="cssVars">
      <error-page-content
        :status-code="statusCode"
        :api-code="apiCode"
        :summary="errorSummary"
        :message="errorMessage"
        :active-my-store-id="myStoreStore.activeMyStoreId"
        :cookie-error="errorType === 'cookie'"
        @logout="handleLogout"
      />
    </div>
  </NuxtLayout>
</template>

<script setup>
import { useStore } from '@/stores/index'
import { useChirashiStore } from '@/stores/chirashi'
import { useMyStoreStore } from '@/stores/myStore'

const rootStore = useStore()
const chirashiStore = useChirashiStore()
const myStoreStore = useMyStoreStore()
const route = useRoute()
const error = useError()
const router = useRouter()

const props = defineProps({
  error: {
    type: Object,
    default: null,
  },
})

const apiStatusCodes = ref({
  10000: 422,
  10003: 400,
  10004: 400,
  10301: 400,
  10302: 400,
  10311: 400,
  99999: 500,
  10202: 422,
  10209: 422,
  10001: 401,
  10002: 401,
  10005: 400,
  10006: 400,
  10007: 400,
  10051: 400,
  90001: 500,
})

const statusCode = computed(() => {
  let statusCode = ''
  if (!apiCode.value) {
    statusCode = props.error.statusCode
  } else if (apiStatusCodes.value[props.apiCode]) {
    statusCode = apiStatusCodes.value[props.apiCode]
  } else {
    statusCode = 500
  }
  return statusCode
})

const apiCode = computed(() => {
  return props.error.name && props.error.name.match(/apiError/)
    ? Number(props.error.name.replace(/apiError /, ''))
    : 0
})

const errorSummary = computed(() => {
  if (errorType.value === 'cookie') {
    return 'Cookieが無効にされています'
  }
  else if (statusCode.value === 500) {
    return 'エラーが発生しました'
  }
  else if (statusCode.value === 401) {
    return 'セッションの有効期限が\\n切れています'
  }
  return apiCode.value
    ? props.error.message.split('|')[0]
    : '対象のコンテンツは存在しません'
})

const errorMessage = computed(() => {
  if (errorType.value === 'cookie') {
    return 'このサイトはCookieが有効でないと閲覧できません。\\nブラウザのクッキー設定を有効にして、\\n画面を再読み込みしてください。'
  }
  else if (statusCode.value === 500) {
    return 'ただいま大変混雑しています。しばらく待ってから再度アクセスしてください。'
  }
  else if (statusCode.value === 401) {
    return '閲覧されたページは、一定時間アクセスがなかったため、タイムアウトになりました。「ホームへもどる」ボタンを押して、再度アクセスし直してください。'
  }
  return apiCode.value
    ? props.error.message.split('|')[1]
    : 'ページが存在しない、またはページが削除された可能性があります。\\nホームにもどり、ご覧になりたい情報をお探しください。'
})

const isFlyerView = computed(() => {
  return true
})

const cssVars = computed(() => {
  return {
    '--height': 'calc(100vh - 4.4rem)'
  }
})

const errorType = computed(() => {
  let type = 'error'
  if (props.error?.message === 'cookie-error') {
    type = 'cookie'
  }
  return type
})

const handleLogout = () => {
  rootStore.logout()
}

onMounted(() => {
  console.error(props.error.message)
  rootStore.$patch({ isContentLoaded: true })
})

</script>

<style lang="scss" scoped>
.error {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  justify-content: center;
  height: var(--height);
  background: $color-bg;
  @media screen and (min-width: $tablet-breakpoint) {
    height: calc(100vh - 6.2rem - 8.9rem);
  }
}
</style>
